(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('RcopiaSnomedSearch', RcopiaSnomedSearch);

    RcopiaSnomedSearch.$inject = ['$resource'];

    function RcopiaSnomedSearch($resource) {
        var resourceUrl =  'api/_search/rcopia-snomeds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
